<script>
export default {
  props: {
    title: {
      type: String,
      required: true,
    },
  },
};
</script>

<template>
  <v-toolbar flat>
    <v-list>
      <v-list-tile>
        <v-list-tile-title class="title">
          {{ title }}
        </v-list-tile-title>
      </v-list-tile>
    </v-list>
  </v-toolbar>
</template>



// WEBPACK FOOTER //
// src/components/TwNavigationTitle.vue